var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1745_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1149 17.028L33.3538 3.78866C34.2154 2.92749 34.2154 1.53511 33.3538 0.673949C32.4927 -0.187215 31.1003 -0.187215 30.2391 0.673949L16.9998 13.9133L3.76088 0.673949C2.89932 -0.187215 1.50734 -0.187215 0.646175 0.673949C-0.215392 1.53511 -0.215392 2.92749 0.646175 3.78866L13.8851 17.028L0.646175 30.2673C-0.215392 31.1285 -0.215392 32.5209 0.646175 33.382C1.07535 33.8116 1.63964 34.0274 2.20353 34.0274C2.76742 34.0274 3.33131 33.8116 3.76088 33.382L16.9998 20.1427L30.2391 33.382C30.6687 33.8116 31.2326 34.0274 31.7965 34.0274C32.3604 34.0274 32.9243 33.8116 33.3538 33.382C34.2154 32.5209 34.2154 31.1285 33.3538 30.2673L20.1149 17.028Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1745_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.de1d8dbbd06a6b4016934aa45e46519c.svg";
export { ForwardRef as ReactComponent };